import { STORAGE_USER_COUNTRY } from "constants/variables";
import { PhoneCountry } from "types/PhoneCountries";

export const getCurrentCountry = (
  countryName: string,
  countries?: PhoneCountry[],
) => {
  const currentLanguage = localStorage
    .getItem(STORAGE_USER_COUNTRY)
    ?.toUpperCase();

  // Определение по isoCode из localStorage
  let currentCountry = countries?.find((country) =>
    currentLanguage === "EN"
      ? country.isoCode === "US"
      : country.isoCode === currentLanguage,
  );

  // Если не нашли по isoCode, поиск по имени
  if (!currentCountry && countryName) {
    currentCountry = countries?.find((country) =>
      country.name.toLowerCase().includes(countryName.toLowerCase()),
    );
  }

  return currentCountry;
};
